package com.mvlikhachev.app.presentation.screen.base

import com.mvlikhachev.app.presentation.screen.abstract.UiState

data class BaseUiState<T>(
    val data: T,
    override val isLoading: Boolean = false,
    override val hasNavigateBackShadow: Boolean = false,
    override val hasOverlayOpacity: Boolean = false
) : UiState